import cx from 'classnames'
import { useIntl } from 'react-intl'

import ButtonCinestar from '../../../../Buttons/ButtonCinestar/ButtonCinestar'
import Icon from '../../../../Icon/Icon'
import Typography from '../../../../Typography/Typography'

import './BasketPriceReserve.scss'

const BasketPriceReserve = ({ onReserve, loading, amount, currency, className }) => {
    const intl = useIntl()

    return (
        <div className={cx('basket-price-reserve d-flex rounded p-2', className)}>
            <div className="d-flex gap-2">
                <Icon name={'info-lightblue'} className={'d-none d-md-block mb-auto mt-1'} />
                <Typography color={'basePrimary'} variant={'label'}>
                    {intl.formatMessage({ id: 'basket.reserveText' }, { amount, currency })}
                </Typography>
            </div>
            <ButtonCinestar
                variant={'outlined'}
                className={'bg-white d-flex gap-1'}
                onClick={onReserve}
                disabled={loading}
            >
                {intl.formatMessage(
                    { id: 'basket.reserveBtn' },
                    { span: (chunks) => <span className="d-none d-lg-flex text-nowrap">{chunks}</span> }
                )}
            </ButtonCinestar>
        </div>
    )
}

export default BasketPriceReserve
